import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { clientType, deliveryStatus, exportAirStatus, exportSeaStatus, importStatus, PackageTypes, status, statusArray } from "../../../assets/data/data";
import { useDispatch } from "react-redux";
import { handlePutRequest } from "../../../services/PutTemplate";
import { toast } from "react-toastify";
import { handleGetRequest } from "../../../services/GetTemplate";
import { checkInvoiceConflicts } from "../../../services/invoiceConflictService";
import InvoiceConflictDialog from "../../../components/InvoiceConflictDialog";

function ChangeStatusDialog({ onHideChangeDialog, onsuccessChange, data, id, unpaid }) {
    console.log(data);
    const [selectedImportStatus, setSelectedImportStatus] = useState();
    const [selectedPackType, setSelectedPAckType] = useState();
    const [selectedExportSeaStatus, setSelectedExportSeaStatus] = useState();
    const [selectedDeliveryStatus, setSelectedDeliveryStatus] = useState();
    const [selectedExportAirStatus, setSelectedExportAirStatus] = useState();
    const [selectedShipment, setSlectedShipment] = useState();
    const [shipmentNumber, setShipmentNumber] = useState();
    const [status, setStatus] = useState([]);
    const [role, setrole] = useState("");
    const [packageStatus, setPackageStatus] = useState([]);
    const [conflicts, setConflicts] = useState([]);
    const [showConflicts, setShowConflicts] = useState(false);
    const [checkingConflicts, setCheckingConflicts] = useState(false);

    console.log("how true unpaid", unpaid);

    const dispatch = useDispatch();

    const getData = async () => {
        const resa = await handleGetRequest(`/getAllPackageStatus`);
        setPackageStatus(resa?.data);
    };

    useEffect(() => {
        const role = localStorage.getItem("role");
        setrole(role);
        getData();
    }, []);

    const handleUnpaid = (e, id) => {
        if (unpaid?.length > 0) {
            data = unpaid.map((val) => {
                return {
                    id: val?.Waybill,
                    name: val?.name?.firstName + " " + val?.name?.lastName,
                    type: "client",
                    description: [val?.description],
                    email: val?.name?.email,
                    deliveryInfo: val?.deliveryInfo,
                    tracking: [val?.trackingNumber],
                    shipmentMethod: val?.shipmentMethod,
                    deliveryInfo: val?.deliveryInfo,
                };
            });
            return data;
        } else {
            return [];
        }
    };

    const submitStatusChange = async (e, waybills) => {
        const dat = {
            status: e,
            package: e === "Package Arrived" ? handleUnpaid(e, id) : data,
            ids: waybills,
        };
        onHideChangeDialog();
        const res = await handlePutRequest(dat, "/packageStatusChangeBulk");

        if (res?.success) {
            toast.success("Package edited");
            onsuccessChange();
        }
    };

    const handledeliveryStatus = async (e) => {
        setSelectedImportStatus(e);

        if (e === "Ready for Flight") {
            setCheckingConflicts(true);
            let foundConflicts;
            try {
                foundConflicts = await checkInvoiceConflicts(id);
            } finally {
                setCheckingConflicts(false);
            }
            if (foundConflicts.length > 0) {
                setConflicts(foundConflicts);
                setShowConflicts(true);
                return;
            }
        }

        await submitStatusChange(e, id);
    };

    // "Change Status, Skip Invoice for These" - status still applies to every
    // selected waybill; the already-invoiced ones are automatically excluded
    // from invoicing server-side (see utils/common/invoiceGuard.js).
    const handleProceedAnyway = async () => {
        setShowConflicts(false);
        await submitStatusChange(selectedImportStatus, id);
    };

    // Excludes the flagged waybills from this action entirely - no status
    // change and no invoice for them.
    const handleRemoveAndContinue = async (conflictWaybills) => {
        setShowConflicts(false);
        const remaining = id.filter((w) => !conflictWaybills.includes(w));
        await submitStatusChange(selectedImportStatus, remaining);
    };

    const handleCancelConflicts = () => {
        setShowConflicts(false);
        setConflicts([]);
    };

    return (
        <>
            <form className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid grid mb-12" style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ marginTop: "10px", display: "flex", flexDirection: "column" }}>
                        <label htmlFor="status" className="Label__Text">
                            Package Status
                        </label>
                        <select disabled={role === "client" || checkingConflicts} style={{ marginTop: "10px", height: "34px", border: "1px solid #cecece", borderRadius: "7px" }} value={selectedDeliveryStatus} onChange={(e) => handledeliveryStatus(e.target.value)}>
                            <option disabled selected>
                                Please select a status
                            </option>
                            {packageStatus?.map((client) => {
                                return <option value={client?.name}>{client?.name}</option>;
                            })}
                        </select>
                        {checkingConflicts && <span style={{ fontSize: "0.8rem", color: "#888", marginTop: 4 }}>Checking for existing invoices...</span>}
                    </div>
                </div>
                <div className="Down__Btn">
                    <Button label="Create" className="Btn__Dark" />
                </div>
            </form>
            <InvoiceConflictDialog visible={showConflicts} conflicts={conflicts} mode="statusChange" onProceedAnyway={handleProceedAnyway} onRemoveAndContinue={handleRemoveAndContinue} onCancel={handleCancelConflicts} />
        </>
    );
}

export default ChangeStatusDialog;
